import { UPDATE } from 'react-admin';

export const SEND_EMAILS = 'SEND_EMAILS';
export const sendEmails = (id, data, basePath) => ({
    type: SEND_EMAILS,
    payload: { id, data: { ...data, is_sent: true, is_approved: true } },
    meta: { fetch: UPDATE, resource: 'emails' },
});